export type FairFareQueryParams = {
  page?: number;
  pageSize?: number;
  whereKey?: string;
  whereValue?: string | number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  fromDate?: Date;
  untilDate?: Date;
  status?: string;
  /**
   * Named filters sent as-is (search, claimType, ...). Empty values are
   * dropped, so "All" in a dropdown simply sends nothing.
   */
  filters?: Record<string, string | undefined>;
};

export const DEFAULT_QUERY_PARAMS: FairFareQueryParams = {
  page: 1,
  pageSize: 20,
  whereKey: undefined,
  whereValue: undefined,
  sortBy: undefined,
  sortOrder: undefined,
  fromDate: undefined,
  untilDate: undefined,
};

export const getFairFareQueryParams = (
  query: FairFareQueryParams
): { [key: string]: string | number | undefined | Date } => {
  const params: { [key: string]: string | number | undefined | Date } = {
    page: query.page || DEFAULT_QUERY_PARAMS.page,
    pageSize: query.pageSize || DEFAULT_QUERY_PARAMS.pageSize,
    sortBy: query.sortBy || DEFAULT_QUERY_PARAMS.sortBy,
    sortOrder: query.sortOrder || DEFAULT_QUERY_PARAMS.sortOrder,
    from: query.fromDate || DEFAULT_QUERY_PARAMS.fromDate,
    until: query.untilDate || DEFAULT_QUERY_PARAMS.untilDate,
    status: query.status,
  };
  const { whereKey, whereValue } = query;

  if (whereKey && whereValue) {
    params[whereKey] = whereValue;
  }

  Object.entries(query.filters || {}).forEach(([key, value]) => {
    if (value) params[key] = value;
  });

  return params;
};
